import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  SelectionType,
} from "@swimlane/ngx-datatable";
import { Address } from "src/components/shared-components/class/component-classes/address";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { iAddressSearch } from "src/components/shared-components/interfaces/iAddress-search";
import { Control } from "src/model/class/general classes/control";
import { ControlGroup } from "src/model/class/general classes/control-group";
import { GenericTableAnagraphTable } from "src/model/class/general classes/generic-table-anagraph-table";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { ApiErrorType } from "src/model/enum/enumApiErrorType";
import { StateControl } from "src/model/enum/enumControl";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { AddressService } from "src/service/address.service";
import { AlertService } from "src/service/alert.service";
import { EventService } from "src/service/event.service";
import { LoadControlService } from "src/service/load-control.service";
import { LoaderService } from "src/service/loader.service";
import { MqttClientService } from "src/service/mqtt-client.service";
import { NetworkService } from "src/service/network.service";
import { LoggerService } from "src/service/logger.service";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iGenericTable } from "src/model/interface/iGeneric-table";
import { Column, TableInfo, ValueToChange } from "src/components/shared-components/class/general-classes/item-history";
import { ColumnTableType, HideShowColumn, SortOrder } from "src/components/shared-components/enum/enumTableHistory";

@Component({
    selector: "app-load-control-list",
    templateUrl: "./load-control-list.component.html",
    styleUrls: ["./load-control-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadControlListComponent
  extends GenericTableAnagraphTable
  implements OnInit, OnDestroy, iTranslation, iEvent, iGenericTable {
  private _logContext: string = "Load-control-list.component";

  private _loadControlSubscription: Subscription = null;
  private _intervalTime: number = 4000;

  private _networkServiceSubscription: Subscription = null;

  //#region Translation
  private _translateSubscription: Subscription = null;
  private _description = "description";
  private _controlModeAuto = "Auto";
  private _controlModeAutoOn = "";
  private _controlModeAutoOff = "Auto off";
  private _controlModeForceOn = "Force on";
  private _controlModeForceOff = "Force off";
  private _controlModeRestore = "";
  private _lblNew: string = "";
  private _name: string = "name";
  private _offCommand: string = "offCommand";
  private _offDelayTime: string = "offDelayTime";
  private _onCommand: string = "onCommand";
  private _onDelayTime: string = "onDelayTime";
  private _priority: string = "priority";
  private _state = "state";
  private _stateAddress: string = "stateAddress";
  private _totalPowerUsedAddress: string = "totalPowerUsedAddress";
  private _useP1: string = "useP1";
  private _useP2: string = "useP2";
  //#endregion

  private _auto: string = "auto";

  private _addressCtrlGroupInfos: string[] = [];
  private _addressCtrlInfos: Map<number, string> = new Map<number, string>();
  private _loadControlGroupList: Array<ControlGroup> = new Array<ControlGroup>();

  public _eventSubscriptions: Array<Subscription> = null;

  public toolBarColor: string = "primary";
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  public tableInfo: TableInfo = null;
  public tableInfoSecond: TableInfo = null;
  public selected: Array<any> = new Array<any>();
  public selectedSecond: Array<any> = new Array<any>();

  constructor(
    private _alertService: AlertService,
    private _loadControlService: LoadControlService,
    private _loaderController: LoaderService,
    private _translateService: TranslateService,
    private _eventService: EventService,
    private _mqttService: MqttClientService,
    private _networkService: NetworkService,
    private _addressService: AddressService,
    private _loggerService: LoggerService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.tableInfo = StaticClass.createTableInfo("material expandable", false, SelectionType.single, this.createArrayColumns(), false, true);
    this.tableInfo.IsListInitialized = false;
    this.tableInfo.RowHeight = this._auto;
    this.tableInfoSecond = StaticClass.createTableInfo("", false, SelectionType.single, this.createArrayColumnsSecondTable(), false, false);
    this.tableInfoSecond.Sorts = StaticClass.createSortInfoObject(this._priority, SortOrder.ASC);
    this.tableInfoSecond.RowHeight = this._auto;

    this.subscribeEvents();
    this.loadTranslation();
    this.subscribeTranslationEvent();

    this.subscribeLoadControlService();
    this.subscribeNetworkServiceData();

    this._loadControlService.Init();
  }

  public ngOnDestroy(): void {
    this._loadControlSubscription.unsubscribe();
    this._translateSubscription.unsubscribe();
    this._networkServiceSubscription.unsubscribe();
    this.unsubscribeEvents();
  }

  OnChanges(): void {
    if (!this.CurrentObject) {
      this.selected = [];
      this.selectedSecond = [];
    } else if (this.CurrentObject.priority != null &&
      this.selectedSecond.length == 0) {
      this.selectedSecond.push(this.CurrentObject);
      this.changedSelected.emit(this.CurrentObject);
    }
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.newMale",
        "dictionary.auto",
        "dictionary.autoOff",
        "dictionary.forceOn",
        "dictionary.forceOff",
        "dictionary.autoOn",
        "dictionary.restore"
      ])
      .subscribe((translation) => {
        this._lblNew = translation["dictionary.newMale"];
        this._controlModeAuto = translation["dictionary.auto"];
        this._controlModeAutoOff = translation["dictionary.autoOff"];
        this._controlModeForceOn = translation["dictionary.forceOn"];
        this._controlModeForceOff = translation["dictionary.forceOff"];
        this._controlModeAutoOn = translation["dictionary.autoOn"];
        this._controlModeRestore = translation["dictionary.restore"];
      });
  }

  public subscribeTranslationEvent(): void {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
        this.createItemHistoryDesktopList();
      }
    );
  }
  //#endregion

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OncontrolGroupChange.pipe(
        filter(() => this.allowDetectionListChange)
      ).subscribe(async (idControlGroupChanged_ClientID: string) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          " _eventService ",
          " OncontrolGroupChange ",
          "Allow DetectionLIst: " +
          this.allowDetectionListChange +
          " | Received OnControlGroupChange from client: " +
          idControlGroupChanged_ClientID
        );

        const idControlGroupChanged_ClientIDSplit =
          idControlGroupChanged_ClientID.split("|");
        if (
          idControlGroupChanged_ClientIDSplit[1] !== this._mqttService.clientID
        ) {
          await this._alertService.presentAlertDataUpdated();
        }
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Receives the selected item in the table and issues it to the form.
   * @param selected 
   */
  public selectionChanged(selected: any): void {
    let selectedElem = null;
    if (this._onDelayTime in selected[0]) {
      selectedElem = this._loadControlGroupList.find(ctrl => ctrl.id === selected[0].id);
      if (selectedElem) {
        this.selected = [];
        this.selectedSecond = [];
        this.selected.push(selected[0]);
      }
    } else {
      let ctrl = this._loadControlGroupList.find(ctrl => ctrl.id === selected[0].idControlGroup);
      if (ctrl) {
        selectedElem = ctrl.details.find(c => c.id === selected[0].id);
        if (selectedElem) {
          this.selectedSecond = [];
          this.selected = [];
          this.selectedSecond.push(selected[0]);
        }
      }
    }
    if (selectedElem) {
      this.changedSelected.emit(selectedElem);
    }
  }

  /**
   * Reloads the data.
   * @param reload 
   */
  public reloadData(reload: string): void {
    this._loadControlService.reloadServiceData();
  }

  /**
   * Create a new control group or a new control.
   */
  public async onRequestNew(): Promise<void> {
    await this._loaderController.presentLoaderWaiting();

    try {
      let newControlGroup: ControlGroup = new ControlGroup();
      newControlGroup.name = this._lblNew;
      newControlGroup.description = this._lblNew;

      newControlGroup = await this._loadControlService.InsertControlGroup(
        newControlGroup
      );

      await this._loaderController.dismissLoaderWaiting();
      this.selectionChanged([newControlGroup]);
    } catch (error) {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "onRequestNew()",
        "ERROR: " + error.message
      );

      await this._loaderController.dismissLoaderWaiting();

      await this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * Creates the array containing the objects to show in the app view.
   */
  public createItemHistoryList(): void {
  }

  /**
   * Creates and returns the columns to pass to the table.
   */
  public createArrayColumns(): Column[] {
    let columns: Column[] = [];
    columns.push(StaticClass.createColumnObj(this._name, this._name, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._totalPowerUsedAddress, "totPowUsedAdd", "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj("p0", "pow0", "", ColumnTableType.ROUND_NUMBER_2, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj("p1", "pow1", "", ColumnTableType.ROUND_NUMBER_2, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj(this._useP1, "usePow1", "", ColumnTableType.ICON, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj("p2", "pow2", "", ColumnTableType.ROUND_NUMBER_2, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj(this._useP2, "usePow2", "", ColumnTableType.ICON, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj("minPower", "minPow", "", ColumnTableType.ROUND_NUMBER_2, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj("p1P2Time", "p1p2Time", "", ColumnTableType.STRING, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj(this._onDelayTime, this._onDelayTime, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._offDelayTime, this._offDelayTime, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    return columns;
  }

  /**
   * Creates and returns the columns to pass to the second table.
   */
  public createArrayColumnsSecondTable(): Column[] {
    let columns: Column[] = [];
    columns.push(StaticClass.createColumnObj(this._priority, this._priority, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._name, this._name, "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._description, this._description, "", ColumnTableType.STRING, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj(this._state, "stateCtrl", "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._stateAddress, "stateAddLoad", "", ColumnTableType.STRING, HideShowColumn.SHOW));
    columns.push(StaticClass.createColumnObj(this._onCommand, this._onCommand, "", ColumnTableType.STRING, HideShowColumn.HIDE_1000));
    columns.push(StaticClass.createColumnObj(this._offCommand, this._offCommand, "", ColumnTableType.STRING, HideShowColumn.HIDE_1000));
    return columns;
  }

  /**
   * Creates the table rows.
   */
  public createItemHistoryDesktopList(): void {
    this.tableInfo.List = [];
    let valuesToChange: ValueToChange[] = [];
    let valuesToChangeDetails: ValueToChange[] = [];
    let ctrlList: ControlGroup[] = this._loadControlGroupList;
    for (let i = 0; i < ctrlList.length; i++) {
      valuesToChange.push(StaticClass.createValueToChange(this._totalPowerUsedAddress, i, this.writeAddressCtrlGroup(ctrlList[i])));
      valuesToChange.push(StaticClass.createValueToChange(this._useP1, i, StaticClass.createSubtitle("", "", this.getIconByValue(ctrlList[i].useP1), "")));
      valuesToChange.push(StaticClass.createValueToChange(this._useP2, i, StaticClass.createSubtitle("", "", this.getIconByValue(ctrlList[i].useP2), "")));
      for (let j = 0; j < ctrlList[i].details.length; j++) {
        valuesToChangeDetails.push(StaticClass.createValueToChange(this._stateAddress, j, this.writeAddressCtrl(ctrlList[i].details[j])));
        valuesToChangeDetails.push(StaticClass.createValueToChange(this._state, j, this.getState(ctrlList[i].details[j].state)));
      }
      valuesToChange.push(StaticClass.createValueToChange("details", i, StaticClass.createArrayForTable(ctrlList[i].details, valuesToChangeDetails)));
      valuesToChangeDetails = [];
    }
    this.tableInfo.List = StaticClass.createArrayForTable(ctrlList, valuesToChange);
  }

  /**
   * Returns the control status
   * @param value value to convert to string
   */
  private getState(value: number): string {
    if (value === StateControl.Auto) return this._controlModeAuto;
    else if (value === StateControl.AutoOff) return this._controlModeAutoOff;
    else if (value === StateControl.ForceOn) return this._controlModeForceOn;
    else if (value === StateControl.AutoOn) return this._controlModeAutoOn;
    else if (value === StateControl.Restore) return this._controlModeRestore;
    else return this._controlModeForceOff;
  }

  /**
   * Returns the name of the icon based on the given value.
   * @param value  
   */
  private getIconByValue(value: boolean): string {
    return value ? "checkmark-sharp" : "close-sharp";
  }

  /**
   * Load commands and addresses for controls
   */
  private async loadOnOffAddressCtrl(): Promise<void> {
    for (let i = 0; i < this._loadControlGroupList.length; i++) {
      for (let j = 0; j < this._loadControlGroupList[i].details.length; j++) {
        if (this._loadControlGroupList[i].details[j].onCommand != "")
          this._loadControlGroupList[i].details[j].onAddCmd =
            await this.loadOnOffAddressInfo(
              this._loadControlGroupList[i].details[j].onCommand
            );
        if (this._loadControlGroupList[i].details[j].offCommand != "")
          this._loadControlGroupList[i].details[j].offAddCmd =
            await this.loadOnOffAddressInfo(
              this._loadControlGroupList[i].details[j].offCommand
            );
      }
    }
  }

  /**
   * Load the address object and its informations for controls (command)
   * @param command
   * @returns
   */
  private async loadOnOffAddressInfo(command: string): Promise<string> {
    let cmds = command.split(" ");
    let adds = cmds[0].split("_");
    let addressSearchObj: iAddressSearch = {
      Instanceguid: adds[0],
      Address: adds[1],
      Name: "",
      Language: this._translateService.getCurrentLang()
    };
    let currentAddress: Address =
      this._addressService.getAddressByInstanceGUIDAndAddress(adds[0], adds[1]);
    if (!currentAddress || currentAddress == null) {
      await this._addressService
        .getAddressesByInstanceGUIDAndAddressAndName(addressSearchObj)
        .then((result: Array<Address>) => {
          currentAddress = result[0];
        });
    }
    return (
      currentAddress.fullName +
      "-" +
      currentAddress.address +
      " " +
      StaticClass.GetStateNameByValue(currentAddress.states, cmds[1])
    );
  }

  /**
   * Load the address object and its informations for control groups
   * @param id
   * @param instanceguid
   * @param address
   */
  private async loadAddressCtrlGroupInfo(
    value: number,
    instanceguid: string,
    address: string
  ): Promise<void> {
    if (instanceguid != "") {
      let addressSearchObj: iAddressSearch = {
        Instanceguid: instanceguid,
        Address: address,
        Name: "",
        Language: this._translateService.getCurrentLang(),
      };
      let currentAddress: Address =
        this._addressService.getAddressByInstanceGUIDAndAddress(
          instanceguid,
          address
        );
      if (!currentAddress || currentAddress == null) {
        await this._addressService
          .getAddressesByInstanceGUIDAndAddressAndName(addressSearchObj)
          .then((result: Array<Address>) => {
            this._addressCtrlGroupInfos[value] = result[0].fullName;
          });
      } else {
        this._addressCtrlGroupInfos[value] = currentAddress.fullName;
      }
    }
  }

  /**
   * Load the address object and its informations for controls state address
   */
  private async loadStateAddressCtrl(): Promise<void> {
    this._addressCtrlInfos.clear();
    for (let i = 0; i < this._loadControlGroupList.length; i++) {
      for (let j = 0; j < this._loadControlGroupList[i].details.length; j++) {
        if (this._loadControlGroupList[i].details[j].instanceGUIDStateAddress !== "") {
          await this.loadAddressCtrlInfo(
            this._loadControlGroupList[i].details[j].id,
            this._loadControlGroupList[i].details[j].instanceGUIDStateAddress,
            this._loadControlGroupList[i].details[j].stateAddress
          );
        }
      }
    }
  }

  /**
   * Load the address object and its informations for controls
   * @param id
   * @param instanceguid
   * @param address
   */
  private async loadAddressCtrlInfo(
    id: number,
    instanceguid: string,
    address: string
  ): Promise<void> {
    if (instanceguid != "") {
      let addressSearchObj: iAddressSearch = {
        Instanceguid: instanceguid,
        Address: address,
        Name: "",
        Language: this._translateService.getCurrentLang(),
      };
      let currentAddress: Address =
        this._addressService.getAddressByInstanceGUIDAndAddress(
          instanceguid,
          address
        );
      if (!currentAddress || currentAddress == null) {
        await this._addressService
          .getAddressesByInstanceGUIDAndAddressAndName(addressSearchObj)
          .then((result: Array<Address>) => {
            this._addressCtrlInfos.set(id, result[0].fullName);
          });
      } else {
        this._addressCtrlInfos.set(id, currentAddress.fullName);
      }
    }
  }

  /**
   * If the address of the control group has been set it returns this and its name
   * @param row control group
   * @returns
   */
  private writeAddressCtrlGroup(row: any): string {
    const index = this._loadControlGroupList.findIndex(
      (ctrlGroup: ControlGroup) => ctrlGroup.id === row.id
    );
    if (row.totalPowerUsedAddress != "")
      return (
        this._addressCtrlGroupInfos[index] + " - " + row.totalPowerUsedAddress
      );
    return "";
  }

  /**
   * If the address of the control has been set it returns this and its name
   * @param row control
   * @returns
   */
  private writeAddressCtrl(row: Control): string {
    if (row.instanceGUIDStateAddress != "") {
      return this._addressCtrlInfos.get(row.id) + "-" + row.stateAddress;
    }
    return "";
  }

  private async handleApiResponseError(): Promise<void> {
    this.tableInfo.ShowErrorContent = true;
    await this._alertService.presentAlertSomethingWrong();
  }

  /**
   * Handle errors in api call which require peculiar reactions from page;
   * this includes cases where the error is propagated through subject.error()
   */
  private async handlePeculiarApiResponseError(error: any): Promise<void> {
    switch (error.status) {
      case ApiErrorType.NOT_FOUND:
        this.tableInfo.IsFunctionalityNotImplemented = true;
        break;
      default:
        this.handleApiResponseError();
        break;
    }
  }

  /**
   * Subscribe to the public Observable of "NetworkService", which emits each time the connection change of type/state. A local property is changed to
   * reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;
          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );

          this.tableInfo.List = [...this.tableInfo.List];
          if (this.selectedSecond.length > 0) {
            const rowIndex = this.tableInfo.List.findIndex(
              (x: ControlGroup) =>
                x.id == this.selectedSecond[0].idControlGroup
            );
            this.tableInfo.List[rowIndex].details = [
              ...this.tableInfo.List[rowIndex].details,
            ];
          }
        }
      );
  }

  private subscribeLoadControlService(): void {
    var timer = setTimeout(() => {
      this.handleApiResponseError();
    }, this._intervalTime);
    this._loadControlSubscription = this._loadControlService.controlGroupList
      .pipe(
        filter((res) => res !== null),
        map((listControl) => {
          return listControl || [];
        })
      )
      .subscribe(
        async (listControlGroup: Array<ControlGroup>) => {
          clearTimeout(timer);
          if (this._loadControlService.isErrorInGetControlGroupListAPIRequest) {
            this.tableInfo.IsListInitialized = false;
            this.handleApiResponseError();
          } else {
            this._loadControlGroupList = listControlGroup;
            this._addressCtrlGroupInfos = [];
            for (let i = 0; i < this._loadControlGroupList.length; i++) {
              let [controls, addresses] = await Promise.all([
                this._loadControlService.GetControlByControlGroupID(
                  this._loadControlGroupList[i].id
                ),
                this.loadAddressCtrlGroupInfo(
                  i,
                  this._loadControlGroupList[i].instanceGUIDTotalPowerUsed,
                  this._loadControlGroupList[i].totalPowerUsedAddress
                ),
              ]);
              this._loadControlGroupList[i].details = [];
              if (controls != null) {
                if (controls instanceof Array) {
                  this._loadControlGroupList[i].details = [
                    ...this._loadControlGroupList[i].details,
                    ...controls,
                  ];
                } else {
                  this._loadControlGroupList[i].details = [
                    ...this._loadControlGroupList[i].details,
                    controls,
                  ];
                }
              }
            }
            this.loadOnOffAddressCtrl();
            await this.loadStateAddressCtrl();
            this.createItemHistoryDesktopList();
            if (
              this.selected.length > 0
            ) {
              let updateCtrl = this.tableInfo.List.find(
                (x: ControlGroup) => x.id === this.selected[0].id
              );
              this.selected = [];
              this.selected.push(updateCtrl);
              updateCtrl = this._loadControlGroupList.find(
                c => c.id === this.selected[0].id
              );
              this.changedSelected.emit(updateCtrl);
            }
            if (
              this.selectedSecond.length > 0
            ) {
              let updateCtrlGroup = this._loadControlGroupList.find(
                (x: ControlGroup) =>
                  x.id === this.selectedSecond[0].idControlGroup
              );
              if (updateCtrlGroup) {
                let updateCtrl = updateCtrlGroup.details.find(
                  (y: Control) => y.id === this.selectedSecond[0].id
                );
                this.selectedSecond = [];
                this.selectedSecond.push(updateCtrl);
                this.changedSelected.emit(updateCtrl);
              }
            }
            this.tableInfo.IsListInitialized = true;
            this.tableInfo.ShowErrorContent = false;
          }
        },
        (error) => {
          clearTimeout(timer);

          this.handlePeculiarApiResponseError(error);
        }
      );
  }
}
